<template>
    <div @mouseover="getHotelKey()" class="result-slider">
        <!--Картинки вставляем в оба дива и меняем при слиде (два дива для ефекта перелистования)-->
        <div v-show="images.length" ref="sliderWrap" class="slider-wrap">
            <div v-for="(item, key) in images"
                 :key="key"
                 @click.self="click($event)"
                 :style="[{'background-image': `url('${item}')`}, {'background-size': 'cover'}]"
                 class="slide"></div>
        </div>
        <div v-show="!images.length || !sliderShow"
             @click.self="click($event)"
             ref="slide1"
             :style="[{backgroundImage: `url('${defaultimage}')`}, {'background-size': 'cover'}]"
             class="slide1 slide"></div>

        <div v-show="showCounter" class="slider-step-wrap">
            <div v-if="images.length > 1 || defaultImageCount > 1" @click="slide('left')" class="slider-left-btn">
                <div class="btn-left-angle"></div>
            </div>

            <div class="slider-step">
                {{sliderPosition + 1}}
                /
                <span v-if="images.length">{{ images.length }}</span>
                <span v-else>{{ defaultImageCount }}</span>
            </div>

            <div v-if="images.length > 1 || defaultImageCount > 1" @click="slide('right')" class="slider-right-btn">
                <div class="btn-right-angle"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        name: "result-slider",
        props: {
            item: {
                type: Object,
                default: () => { }
            },
            tourImages: {
                type: Array,
                default: () => []
            },
            defaultimage: {
                type: String,
                default: ""
            },
            defaultImageCount: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                key: null,
                images: [],
                btnActive: true,
                sliderShow: false,
                sliderPosition: 0,
                hovered: false,
                imageType: "tour"
            }
        },
        computed: {
            showCounter() {
                let res = false;
                if (this.images.length) {
                    res = !this.images[0].includes("name=null");
                } else {
                    res = !this.defaultimage.includes("name=null");
                }
                return res
            },
            settings() {
                const settings = this.$store.getters['getSettings'];
                // settings.AutomaticLoadingResults = true;
                return settings;
            }
        },
        methods: {
            click(e) {
                let viewRemoteHotels = this.settings.ViewRemoteHotels;
                if(viewRemoteHotels){
                    if(this.item.IsTourImages){
                        this.$emit("click", {e, imageType: this.imageType});
                    }else{
                        let hotels = this.item.Services.filter(x => x.SvKey === 3 && x.Http !== null && x.Http !== "");
                        if (hotels.length > 0){
                            window.open(hotels[0].Http, '_blank');
                        }else{
                            this.$emit("click", {e, imageType: this.imageType});
                        }  
                    }
                }else{
                    this.$emit("click", {e, imageType: this.imageType});
                }
            },
            getHotelKey() {
                const norFoundImage = this.$refs.slide1.style.backgroundImage.includes("null");
                if (this.hovered || norFoundImage) {
                    return
                }
                this.hovered = true;

                const isTour = this.$refs.slide1.style.backgroundImage.includes("tours");
                this.imageType = isTour ? "tour" : "hotel";
                const imageType = isTour ? "Tour" : "Hotel";
                const hotel = this.item.Services.find(x => x.SvKey === 3);

                let key = hotel?.Hotel?.Key;
                if (isTour) {
                    key = this.item.Key;
                    this.images = this.tourImages;
                    return;
                }
                if (!key) return;

                let date = new Date().getTime();
                let path=this.$store.getters['getPath'];
                Vue.Api.Get(this.$store.getters['getApiUrl'] + `${imageType}Images?${imageType}Key=${key ? key : 639}&_=` + date)
                    .then(res => {
                        let imagesData = res.data.Images || [];
                        let images = [];
                        imagesData.forEach(x => {
                            images.push(`${this.$store.getters['getApiOrigin']}${path}/Image/GetImage?code=${x[`${imageType}Key`] ? x[`${imageType}Key`] : 639}&type=medium&name=${x.Name}&imageType=${imageType.toLowerCase()}s`)
                        });
                        this.images = images
                    });
            },
            slide(to) {
                const sliderWrap = this.$refs.sliderWrap;

                if (this.btnActive) {
                    this.btnActive = false
                } else {
                    return
                }
                if (to === 'right') {
                    if (this.images[this.sliderPosition + 1]) {
                        this.sliderPosition++;
                    } else {
                        this.sliderPosition = 0;
                    }
                    const translate = this.sliderPosition * 100;
                    const margin = this.sliderPosition * 10;
                    sliderWrap.style.transform = `translateX(calc(-${translate}% - ${margin}px))`;

                    setTimeout(() => {
                        this.btnActive = true;
                    }, 400)
                } else {
                    if (this.images[this.sliderPosition - 1]) {
                        this.sliderPosition--;
                    } else {
                        this.sliderPosition = this.images.length - 1;
                    }
                    const translate = this.sliderPosition * 100;
                    const margin = this.sliderPosition * 10;
                    sliderWrap.style.transform = `translateX(calc(-${translate}% - ${margin}px))`;

                    setTimeout(() => {
                        this.btnActive = true;
                    }, 400)
                }
            }
        },
        watch: {
            images(val) {
                this.sliderShow = val.length;
            },
            defaultimage() {
                this.hovered = false;
                this.images = [];
            }
        }
    }
</script>

<style scoped>
    .result-slider {
        position: relative;
        height: 100%;
        overflow: hidden;
    }

    .result-slider .slider-wrap {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        transition: .4s;
    }

    .result-slider .slide {
        min-width: calc(100% + 10px);
        min-height: calc(100% + 10px);
        transform: translate(-5px, -5px);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        transition: all .4s;
    }

    .result-slider .slider-left-btn,
    .result-slider .slider-right-btn{
        width: 18px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all .2s;
        cursor: pointer;
    }

    .result-slider .slider-left-btn {
        margin-right: 4px;
    }

    .result-slider .slider-right-btn {
        margin-left: 4px;
    }

    .result-slider:hover .slider-left-btn,
    .result-slider:hover .slider-right-btn{
        opacity: 1;
    }
    .result-slider .btn-left-angle,
    .result-slider .btn-right-angle{
        width: 10px;
        height: 10px;
        border-top: 2px solid var(--white-color);
        border-left: 2px solid var(--white-color);
    }
    .result-slider .btn-left-angle{
        transform: rotate(-45deg)
    }
    .result-slider .btn-right-angle{
        transform: rotate(135deg)
    }
    .result-slider .slider-step-wrap{
        position: absolute;
        bottom: 13px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .2s;
    }
    .result-slider .slider-step{
        background: #c4c4c4;
        opacity: .8;
        box-sizing: border-box;
        border-radius: 4px;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        color: var(--white-color);
        padding: 2px 9px;
    }
</style>
